import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faMobile, faPhone } from "@fortawesome/pro-regular-svg-icons";

export const iconLookup: Record<string, Function> = {
  Email: () => <FontAwesomeIcon className='tw-text-purple' icon={faEnvelope} />,
  Phone: () => <FontAwesomeIcon className='tw-text-orange' icon={faPhone} />,
  App: () => <FontAwesomeIcon className='tw-text-teal' icon={faMobile} />,
};
